import { ShowChart } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import * as THREE from "three";
export function ObjectHighlighterButton({ object }: { object: THREE.Object3D }) {
  if (!object) return null;
  return (
    <IconButton
      size="small"
      onMouseDown={() => {
        if (!object) return;
        const axesHelper = new THREE.AxesHelper(1.5);
        axesHelper.name = `designator`;
        object.add(axesHelper);
      }}
      onMouseUp={() => {
        if (!object) return;
        const axesHelper = object.getObjectByName(`designator`);
        if (axesHelper) {
          object.remove(axesHelper);
        }
      }}
    >
      <ShowChart />
    </IconButton>);
}
